<section class="login">
	<div class="login__title">
	</div>
	<div className="{nuevo ? 'nuevo login__container':'login__container'}" *ngIf="!mensaje && !mensajeValidacion"
		class="login__container">

		<div class="content">
			<div class="login__container__title">
				<h2>{{title}}</h2>
				<p>{{subTitle}}</p>
			</div>
			<div *ngIf="!recuperar && !passReset" class="login__container__form">
				<label>Cedula de identidad</label>
				<input [(ngModel)]="dpi" type="text" (keypress)="onlyNumber($event)" minlength="7" maxlength="10"
					placeholder="Ingresa tu cedula de identidad">
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Nombres</label>
				<input [(ngModel)]="nombre" type="text" (keyup)="onlyLetter($event)" maxlength="30"
					placeholder="Ingresa tu Nombre">
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Primer Apellido</label>
				<input [(ngModel)]="apePaterno" type="text" (keyup)="onlyLetter($event)" maxlength="30"
					placeholder="Ingresa tu Primer Apellido">
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Segundo Apellido <span>(Opcional)</span></label>
				<input [(ngModel)]="apeMaterno" type="text" (keyup)="onlyLetter($event)" maxlength="30"
					placeholder="Ingresa tu Segundo Apellido">
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Sexo</label>
				<select [(ngModel)]="sexo">
					<option value="M">Masculino</option>
					<option value="F">Femenino</option>
				</select>
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Fecha de Nacimiento</label>
				<input [(ngModel)]="fecNacimiento" max="{{fechaAux | date:'yyyy-MM-dd'}}" type="date"
					placeholder="Ingresa tu Fecha de Nacimiento">
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Nacionalidad</label>
				<input [(ngModel)]="nacionalidad" maxlength="20" type="text" (keyup)="onlyLetterWhitoutSpace($event)"
					placeholder="Ingresa tu Nacionalidad">
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Dirección</label>
				<input [(ngModel)]="direccion" maxlength="80" type="text" placeholder="Ingresa tu Dirección">
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Número de Teléfono</label>
				<input [(ngModel)]="tel" type="text" maxlength="20" (keypress)="onlyNumber($event)"
					placeholder="Ingresa tu Teléfono">
			</div>
			<div *ngIf="!default && !passReset && !validaCorreo" class="login__container__form">
				<label>Correo Electrónico</label>
				<input [(ngModel)]="email" type="email" maxlength="50" placeholder="nombre.apellido@dominio.com" />
			</div>
			<div *ngIf="!default && !passReset && !validaCorreo" class="login__container__form">
				<label>Repetir correo Electrónico</label>
				<input [(ngModel)]="REemail" type="email" maxlength="50" placeholder="nombre.apellido@dominio.com" />
				<p *ngIf="!comprobReEmail() && REemail" class="alert red">Ambos email deben ser iguales</p>
			</div>
			<div *ngIf="(!recuperar || passReset) && !validaCorreo" class="login__container__form">
				<label class="d-flex">
					<div>Contraseña (Maximo 12 caracteres)</div>
					<a class="recovery" *ngIf="default" (click)="change(3)">¿Olvidaste tu contraseña?</a>
				</label>
				<input [(ngModel)]="password" id="password" #pass="ngModel" type="password" placeholder="Ingresa tu Contraseña"
					maxlength="12" (keyup.enter)="send(tipo)">
				<p class="alert red" *ngIf="this.password.length < 6 && pass.dirty">Debe tener al menos 6 caracteres
				</p>
			</div>
			<div *ngIf="nuevo || passReset" class="login__container__form">
				<label class="d-flex">
					<div>Repite Contraseña (Maximo 12 caracteres)</div>
				</label>
				<input [(ngModel)]="password2" type="password" placeholder="Repite tu Contraseña" maxlength="12">
			</div>
			<!-- VALIDA CORREO -->
			<div *ngIf="validaCorreo && !mensajeValidacion" class="login__container__form">
				<label class="d-flex">
					<div>Por favor, haga click en el botón de abajo para validar su correo.</div>
					<!-- <button class="btn" (click)="send(tipo)">{{button}}</button> -->
				</label>
			</div>
			<!-- FIN VALIDA CORREO -->
			<div class="login__container__btn-group">
				<p *ngIf="errorMensaje" class="alert red">{{errorMensaje}}</p>
				<button *ngIf="!passReset && !loading && !validaCorreo" class="btn" (click)="send(tipo)">{{button}}</button>
				<button *ngIf="passReset" class="btn" (click)="resetPassword()">{{button}}</button>
				<button *ngIf="validaCorreo" class="btn" (click)="send(4)">{{button}}</button>
				<div *ngIf="loading" class="lds-ring">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
				<a (click)="change(2)" *ngIf="default">Usuario TransCaribe, quiero registrarme</a>
				<a (click)="change(1)" *ngIf="nuevo">Ya tengo una cuenta, quiero iniciar sesión</a>
				<a (click)="change(1)" *ngIf="recuperar">Volver al comienzo</a>
			</div>
		</div>
	</div>
	<div *ngIf="mensaje" class="login__container">
		<div class="content">
			<div class="login__icon">
				<i class="material-icons">done</i>
				<p>Enviado correctamente</p>
				<button (click)="change(1)" class="btn">Volver</button>
			</div>
		</div>
	</div>
	<div *ngIf="mensajeValidacion" class="login__container">
		<div class="content">
			<div class="login__icon">
				<i class="material-icons">done</i>
				<p>Usuario validado correctamente</p>

				<button (click)="change(1)" class="btn">Volver</button>
			</div>
		</div>
	</div>
</section>
<div class="version">{{version}}</div>